import { mailboxPlatform } from '../../../User/inboxPrompt';
import {
    BOOK_INTENT_DEVICES,
    BOOK_INTENT_DEVICE_MESSENGERS,
} from '../../../User/bookIntent';

// Onglets réels du tutoriel. L'iPhone ne choisit pas entre Mac et PC :
// ce choix n'existe que quand la page est ouverte sur l'ordinateur.
const TUTORIAL_PLATFORMS = {
    sms: ['iphone-mac', 'iphone-pc', 'android'],
    whatsapp: ['iphone', 'android'],
    line: ['iphone', 'android'],
    kakaotalk: ['iphone', 'android'],
};

const PLATFORM_BY_CLIENT = {
    android: 'android',
    ios: 'iphone',
    mac: 'iphone-mac',
    windows: 'iphone-pc',
};

export function detectClientPlatform(userAgent, maxTouchPoints = 0) {
    const phone = mailboxPlatform(userAgent, maxTouchPoints);
    if(phone === 'android' || phone === 'ios') {
        return phone;
    }
    const ua = `${userAgent || ''}`;
    if(/Windows/i.test(ua)) {
        return 'windows';
    }
    if(/Macintosh|Mac OS X/i.test(ua)) {
        return 'mac';
    }
    return 'other';
}

export function readClientPlatform() {
    if(typeof navigator === 'undefined') {
        return 'other';
    }
    return detectClientPlatform(navigator.userAgent, navigator.maxTouchPoints || 0);
}

export function suggestTutorialPlatform(platformIds, clientPlatform) {
    const candidate = PLATFORM_BY_CLIENT[clientPlatform];
    if(!candidate || !BOOK_INTENT_DEVICES.includes(candidate)) {
        return null;
    }
    return (platformIds || []).includes(candidate) ? candidate : null;
}

export function suggestIntentDevice(messenger, clientPlatform) {
    if(!BOOK_INTENT_DEVICE_MESSENGERS.includes(messenger)) {
        return null;
    }
    return suggestTutorialPlatform(TUTORIAL_PLATFORMS[messenger], clientPlatform);
}
